import * as React from "react";
import { Typography, Container, Box } from "@material-ui/core";
import { SecureArea } from "../components/authentication/SecureArea";
import { MemberPermission } from "../services/MemberService";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../services/TelemetryService";
import { RefundsContainer } from "../components/refunds/RefundsContainer";

function Refunds() {
  return (
    <Container maxWidth={"lg"} fixed>
      <SecureArea memberPermission={MemberPermission.SuperAdmin}>
        <Typography variant="h4" color="primary" gutterBottom>
          Refunds
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          View the refunds below, for refunds in pending status you can complete them using the complete refund button.
        </Typography>
        <Box mt={4}>
          <RefundsContainer />
        </Box>
      </SecureArea>
    </Container>
  );
}

export default withAITracking(reactPlugin, Refunds, "Refunds");
